import { render, staticRenderFns } from "./onboarding-nav.vue?vue&type=template&id=30a3594e&lang=pug&"
import script from "./onboarding-nav.vue?vue&type=script&lang=js&"
export * from "./onboarding-nav.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-nav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports